// Mock data for Full-Bin UK Ltd website

export const companyInfo = {
  name: "Full-Bin UK Ltd",
  tagline: "Sustainability & Awareness",
  founded: "2023",
  location: "London, United Kingdom",
  address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ",
  email: "christian@full-bin.com",
  phone: "+44 20 3996 2569",
  website: "www.full-bin.com",
  ceo: "Christian Herbert"
};

export const oh4Stats = [
  {
    value: "13-31%",
    label: "Energy Savings",
    description: "Proven reduction in energy usage for heating systems"
  },
  {
    value: "12-24 months",
    label: "Payback Period",
    description: "Quick return on investment"
  },
  {
    value: "10+ years",
    label: "Lifespan",
    description: "Continues working with zero maintenance"
  },
  {
    value: "Zero",
    label: "Ongoing Costs",
    description: "No maintenance, no parasitic load"
  }
];

export const oh4Features = [
  {
    title: "Frequency Programming Technology",
    description: "Enhances heat transfer by organizing water molecules and increasing Hydrogen/Oxygen bonds in your heating system pipework."
  },
  {
    title: "Simple Tape Application",
    description: "Easy installation on existing pipework. Works with gas boilers, electric boilers, oil boilers, and heat pumps (ground source & air source)."
  },
  {
    title: "Zero Maintenance Required",
    description: "Once installed, the OH4 system works indefinitely with no ongoing costs, no maintenance, and no parasitic load."
  },
  {
    title: "Reusable Technology",
    description: "Can be removed and reused on future systems, providing value beyond the initial installation."
  }
];

export const iotSensors = [
  {
    name: "Sensative Strips Multi-Sensor",
    description: "Ultra-thin LoRaWAN sensors with 10-year battery life. Track temperature, humidity, door/window status, and leakage detection. Downloadable apps for customizable sensor behavior.",
    applications: ["Smart buildings", "Property protection", "Energy optimization"],
    technology: "LoRaWAN"
  },
  {
    name: "Air Quality Sensors (IAQ)",
    description: "Monitor indoor air quality with bVOC, CO₂e, temperature, and humidity. Improve meeting productivity and occupant wellbeing with real-time environmental data.",
    applications: ["Office spaces", "Meeting rooms", "Educational facilities"],
    technology: "LoRaWAN & Z-Wave"
  },
  {
    name: "Occupancy & Radar Sensors",
    description: "Advanced radar technology for desk occupancy, seat availability, parking detection, and space utilization. Optimize workspace efficiency and reduce operational costs.",
    applications: ["Property management", "Flexible workspaces", "Parking facilities"],
    technology: "LoRaWAN"
  },
  {
    name: "Water & Leak Detection",
    description: "Protect critical assets with instant leak detection alerts. Ultra-sensitive sensors for water damage prevention in buildings and facilities.",
    applications: ["Commercial buildings", "Data centers", "Cold storage"],
    technology: "LoRaWAN & Z-Wave"
  }
];

export const iotBenefits = [
  {
    title: "Yggio IoT Platform",
    description: "Powered by Sensative's Yggio platform - technology-agnostic orchestration connecting any device, any protocol. Full data sovereignty and EU compliance."
  },
  {
    title: "10-Year Battery Life",
    description: "Ultra-thin, discreet sensors with exceptional longevity. Minimal maintenance and long-range LoRaWAN connectivity."
  },
  {
    title: "Downloadable Apps",
    description: "Customize sensor behavior to perfectly fit your use case. Multi-functional sensors adapt to changing requirements."
  },
  {
    title: "Proven Reliability",
    description: "Nearly 500,000 Sensative sensors trusted worldwide. Nordic standards of reliability and durability."
  }
];

export const esgServices = [
  {
    title: "ESG Compliance & Frameworks",
    description: "Navigate regulatory requirements and align with recognized frameworks like GRI, SASB, and TCFD. We make compliance straightforward for UK businesses."
  },
  {
    title: "Carbon Footprint Assessment",
    description: "Measure your Scope 1, 2, and 3 emissions. Identify reduction opportunities and track progress year-over-year."
  },
  {
    title: "Sustainability Reporting",
    description: "Professional ESG reports that demonstrate your commitment to stakeholders, investors, and customers. Clear metrics and actionable insights."
  },
  {
    title: "Improvement Roadmaps",
    description: "Practical, achievable plans to reduce environmental impact, improve social responsibility, and strengthen governance."
  }
];

export const esgBenefits = [
  "Demonstrate sustainability leadership to customers and investors",
  "Reduce operational costs through efficiency improvements",
  "Meet regulatory requirements and stay ahead of legislation",
  "Attract talent who value environmental responsibility",
  "Access green financing and tender opportunities",
  "Build brand reputation and trust in the market"
];

export const services = [
  {
    title: "OH4 Heat Transfer System",
    description: "Frequency programming tape for closed water heating systems. Reduce fuel consumption by 13-31% with zero maintenance.",
    link: "/oh4"
  },
  {
    title: "Sensative IoT Sensors",
    description: "Award-winning LoRaWAN sensors with 10-year battery life. Real-time monitoring for air quality, occupancy, leaks, and environmental conditions.",
    link: "/iot-sensors"
  },
  {
    title: "Awaab's Law Compliance",
    description: "Damp & mould detection systems for social housing. Meet UK regulations with 24/7 monitoring and instant alerts. Prevent costly repairs.",
    link: "/awaabs-law"
  },
  {
    title: "ESG Reporting & Support",
    description: "Practical ESG compliance, carbon assessments, sustainability reporting, and improvement strategies.",
    link: "/esg-support"
  }
];

export const testimonials = [
  {
    quote: "The OH4 system reduced our chiller energy consumption by 22% in the first six months. The ROI was faster than expected.",
    author: "Facilities Director",
    company: "Major UK Retail Chain"
  },
  {
    quote: "Full-Bin's IoT sensors gave us real-time visibility into our warehouse operations. We've optimized HVAC schedules and cut costs significantly.",
    author: "Operations Manager",
    company: "Logistics Provider"
  },
  {
    quote: "Their ESG reporting service made compliance straightforward. We now have a clear roadmap for sustainability improvements.",
    author: "Managing Director",
    company: "Manufacturing SME"
  }
];
